import { apiClient } from '@/utils/axios'

const updateAgencyLogo = async (
  data: Blob,
  isDarkMode?: boolean,
  mime?: string,
): Promise<any> => {
  const response = await apiClient.post(
    `/logo?isDarkMode=${!!isDarkMode}`,
    data,
    {
      headers: { 'Content-Type': mime || 'image/png' },
    },
  )

  return response.data
}

const resetAgencyLogo = async (): Promise<any> => {
  const response = await apiClient.post(`/logo/reset`)

  return response.data
}

export const logoService = { updateAgencyLogo, resetAgencyLogo }
